<svg xmlns="http://www.w3.org/2000/svg" width="42" height="42" fill="none" viewBox="0 0 42 42">
  <path fill-rule="evenodd" d="M12 14h2v6h4v-6h2v14h-2v-6h-4v6h-2V14Z" clip-rule="evenodd"/>
  <path d="M24 16h6v-2h-6a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h4v4h-4v-1h-2v1a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2h-4v-4Z"/>
</svg>
